import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

/**Import Assets */
import styles from "./styles/ProtectedLayout.module.scss";
// import cssStyles from './styles/notification.module.css';

/**Import Custom Component */
import { useAppContext } from "../../Context/AppContext";
import { WEB_ROUTES } from "../../constants";
import Navbar from "./Navbar";

// Icons
import { TbLogout2 } from "react-icons/tb";
import { useLocalizationContext } from "../../Context/LocalizationContext";

import { ReactComponent as AboutIcon } from "./images/about.svg";
import { ReactComponent as DashboardIcon } from "./images/dashboard.svg";
import { ReactComponent as HelpIcon } from "./images/help.svg";
import { ReactComponent as HistoryIcon } from "./images/history.svg";
import { ReactComponent as LabelIcon } from "./images/label.svg";
import { ReactComponent as ParcelIcon } from "./images/parcel.svg";
import { ReactComponent as ShopIcon } from "./images/shop.svg";

export default function ProtectedLayout({
  isSearchBar,
  isSettingButton,
  isNavbar = true,
  selectedRoute,
  hasContentPadding = true,
  children,
  isBack = false,
  isPermanentClose = false
}) {
  const { dictionary } = useLocalizationContext();
  const { logout } = useAppContext();
  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);

  const items = useMemo(() => {
    return [
      {
        label: dictionary.home,
        route: WEB_ROUTES.HOME,
        icon: <DashboardIcon />,
      },
      {
        label: dictionary.tracking_parcel,
        route: WEB_ROUTES.TRACKING_PARCEL,
        icon: <ParcelIcon />,
      },
      {
        label: dictionary.my_labels,
        route: WEB_ROUTES.MY_LABELS,
        icon: <LabelIcon />,
      },
      {
        label: dictionary.transaction_history,
        route: WEB_ROUTES.TRANSACTION_HISTORY,
        icon: <HistoryIcon />,
      },
      {
        label: dictionary.shop,
        route: WEB_ROUTES.SHOP,
        icon: <ShopIcon />,
      },
      {
        label: dictionary.help,
        isModal: true,
        icon: <HelpIcon />,
      },
      {
        label: dictionary.about_us,
        route: WEB_ROUTES.ABOUT_US,
        icon: <AboutIcon />,
      },
    ];
  }, []);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  const handleLogout = () => {
    logout();
    // queryClient.clear()
  };

  return (
    <>
      <div className={styles.ProtectedLayout}>
        {isNavbar && (
          <div className={styles.navbarContainer}>
            <Navbar
              isSearchBar={isSearchBar}
              isSettingButton={isSettingButton}
              handleToggle={handleToggle}
              isBack={isBack}
              isPermanentClose={isPermanentClose}
            // handleNotificationModalOpen={handleNotificationModalOpen}
            />
          </div>
        )}
        <div className={`${styles.contentContainer} ${isNavbar ? "" : styles.noNavbar}`}>
          {/* <div
            className={collapsed ? styles.background : ""}
            onClick={handleMenuClose}
          ></div>
          <div
            className={`${styles.menu} ${collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
              }`}
            id="sider"
          >
            {items.map(({ icon, label, route, isModal }, index) => {
              return !isModal ? (
                <Link
                  to={`${process.env.REACT_APP_DOMAIN_DIR}/${route}`}
                  className={`${styles.item} ${index === selectedRoute ? styles.active : ""
                    }`}
                  key={index}
                >
                  <span style={{ fontSize: "20px", display: "flex" }}>
                    {" "}
                    {icon}{" "}
                  </span>
                  {collapsed ? <p>{label}</p> : ""}
                </Link>
              ) : (
                <Link
                  className={`${styles.item} ${index === selectedRoute ? styles.active : ""
                    }`}
                  key={index}
                  onClick={() => { }}
                >
                  <span style={{ fontSize: "20px", display: "flex" }}>
                    {" "}
                    {icon}{" "}
                  </span>
                  {collapsed ? <p>{label}</p> : ""}
                </Link>
              );
            })}
            <Link
              className={`${styles.item} ${styles.logoutButton}`}
              onClick={handleLogout}
            // onClick={() => submit("Confirm Logout", "Are you sure you want to logout?", () => handleLogout())}
            >
              <span style={{ fontSize: "20px", display: "flex" }}>
                {" "}
                <TbLogout2 />{" "}
              </span>
              {collapsed ? <p>{dictionary.logout}</p> : ""}
            </Link>
          </div> */}
          <div className={`${styles.routeContent}`}>
            <div
              className={`${styles.content} ${hasContentPadding ? styles.padding : ""
                }`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
